import { render, staticRenderFns } from "./ContainsCategory.vue?vue&type=template&id=6a849df8&scoped=true&"
import script from "./ContainsCategory.vue?vue&type=script&lang=js&"
export * from "./ContainsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a849df8",
  null
  
)

export default component.exports